import { MobiDocument } from './MobiDocument';
import { LabelLienDocument } from './LabelLienDocument';
import { Parent } from './Parent';

export class LienIndParDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private autorisation: boolean;
    private isparent: boolean;
    private individu_id: number;
    private parent_id: number;
    private label_lien_id: number;

    public constructor(lienInd: any) {
        super()
        this._id = lienInd._id;
        this._rev = lienInd._rev;
        this.id = lienInd.id;
        this.autorisation = lienInd.autorisation;
        this.isparent = lienInd.isparent;
        this.individu_id = lienInd.individu_id;
        this.parent_id = lienInd.parent_id;
        this.label_lien_id = lienInd.label_lien_id;
    }
    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public isAutorisation(): boolean {
        return this.autorisation;
    }

    public setAutorisation(autorisation: boolean): void {
        this.autorisation = autorisation;
    }

    public isIsparent(): boolean {
        return this.isparent;
    }

    public setIsparent(isparent: boolean): void {
        this.isparent = isparent;
    }

    public getIndividu_id(): number {
        return this.individu_id;
    }

    public setIndividu_id(individu_id: number): void {
        this.individu_id = individu_id;
    }

    public getParent_id(): number {
        return this.parent_id;
    }

    public setParent_id(parent_id: number): void {
        this.parent_id = parent_id;
    }

    public getLabel_lien_id(): number {
        return this.label_lien_id;
    }

    public setLabel_lien_id(label_lien_id: number): void {
        this.label_lien_id = label_lien_id;
    }

    public getLabelLien(): LabelLienDocument {
        return this.memdb.findOne({
            doctype: "LabelLienDocument",
            fkey: "id",
            fvalue: this.label_lien_id
        });
    }

    public getParent(): Parent{
        return this.memdb.findOne({
            doctype: "ParentDocument",
            fkey: "id",
            fvalue: this.parent_id
        });
    }
}